import MuiTablePagination, {
  TablePaginationProps
} from '@mui/material/TablePagination';

export type TTablePaginationProps = TablePaginationProps & {};

const TablePagination = (props: TTablePaginationProps): JSX.Element => {
  return (
    <MuiTablePagination
      {...props}
      size="small"
    />
  );
};

export default TablePagination;
